import { button, el } from "../atoms/dom";
import { icon } from "../atoms/icons";

export function topbar(
  title: string,
  subtitle: string,
  unreadCount: number,
  onLogout: () => void,
) {
  return el(
    "header",
    { className: "topbar" },
    el(
      "div",
      {},
      el("h1", { text: title }),
      el("p", { text: subtitle }),
    ),
    el(
      "div",
      { className: "topbar__actions" },
      el(
        "button",
        {
          className: "icon-button",
          attrs: { type: "button", "aria-label": "Bildirimler" },
        },
        icon("bell"),
        unreadCount > 0
          ? el("span", {
              className: "notification-dot",
              text: String(unreadCount),
            })
          : null,
      ),
      button("Çıkış", onLogout, "quiet"),
    ),
  );
}
